<template>
  <div>
    
    <div>
      <a-row>
        <a-col :span="5">
          <a-input placeholder="作业名" v-model="queryParam.workName"></a-input>
        </a-col>
        <a-col :span="5">
          <j-select-depart v-model="queryParam.departId" :multi="false"></j-select-depart>
        </a-col>
        <a-col :span="5">
          <j-dict-select-tag
            style="width: 120px"
            placeholder="代码类型"
            v-model="queryParam.codeType"
            dictCode="code_type"
          />
        </a-col>
        <!-- <a-col :span="8">
          <a-radio-group v-model="queryParam.workScene" style="margin: 0 20px">
            <a-radio-button value="course">课程作业</a-radio-button>
            <a-radio-button value="additional">自定义教学</a-radio-button>
          </a-radio-group>
        </a-col> -->
        <a-col :span="4">
          <a-button type="primary" @click="search">查询</a-button>
        </a-col>
      </a-row>
      <a-divider></a-divider>
    </div>
    <div>
      <a-table
        class="j-table-force-nowrap"
        :scroll="{x:true}"
        ref="table"
        bordered
        size="middle"
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        @change="handleTableChange"
      >
        <span slot="rate" slot-scope="t">
          <a-rate :disabled="true" :value="t" />
        </span>

        <span slot="action" slot-scope="text, record">
          <a @click="handleViewWork(record)">查看</a>
        </span>
      </a-table>
    </div>
    <WorkReviewModal ref="modalForm" @finished="search" />
  </div>
</template>

<script>
import { teacherCourseWork } from "@/api/course";
import WorkReviewModal from "./modules/WorkReviewModal";
import JDictSelectTag from "@/components/jeecg/JDictSelectTag";
import JSelectDepart from '@/components/jeecg/JSelectDepart'
import { getAction } from "@/api/manage";
import { JeecgListMixin } from "@/utils/JeecgListMixin";

export default {
  name: "TeacherAdditionalWorkGroupByDepart",
  mixins: [JeecgListMixin],
  components: {
    JDictSelectTag,
    WorkReviewModal,
    JSelectDepart
  },
  props: {
    isInner: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      queryParam: { workScene: "course" },
      /* table加载状态 */
      loading: false,
      /* 数据源 */
      dataSource: [],
      /* 分页参数 */
      ipagination: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ["10", "20", "30"],
        showTotal: (total, range) => {
          return range[0] + "-" + range[1] + " 共" + total + "条";
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0,
      },
      columns: [
        {
          title: "班级",
          align: "center",
          width: 100,
          dataIndex: "departName",
        },
        {
          title: "作业名",
          align: "center",
          width: "300px",
          dataIndex: "additionalWorkName",
        },
        {
          title: "代码类型",
          align: "center",
          width: 100,
          dataIndex: "codeType_dictText",
        },
        {
          title: "提交数",
          align: "center",
          width: 100,
          dataIndex: "submitCount",
          customRender(v, r) {
            return r.submitCount + "/" + r.studentCount;
          },
        },
        {
          title: "批改数",
          align: "center",
          width: 100,
          dataIndex: "correctCount",
        },
        {
          title: "布置时间",
          align: "center",
          width: 180,
          dataIndex: "assignTime",
        },
        {
          title: "操作",
          dataIndex: "action",
          align: "center",
          fixed:"right",
          width: "100px",
          scopedSlots: { customRender: "action" },
        },
      ],
      url: {
        list: "/teaching/teachingWork/teacherAdditionalWorkGroupByDepart",
      },
    };
  },
  created() {
    this.search();
  },
  methods: {
    search() {
      this.loading = true;
      this.loadData(1)
      // getAction(
      //   "/teaching/teachingWork/teacherCourseWorkGroupByCourse",
      //   this.queryParam
      // ).then((res) => {
      //   this.dataSource = res.result.records;
      //   this.ipagination.total = res.result.total;
      //   this.loading = false;
      // });
    },
    open(record) {
      console.log(record);
      this.isInner = true;
      this.queryParam.departId = record.id;
      this.search();
    },
    handleViewWork(record) {
      this.$router.push({path: "/teacher/work", query: {departId: record.departId, additionalWorkId: record.additionalWorkId}})
    },
  },
};
</script>

<style lang="less" scoped>
@import '~@assets/less/common.less';
</style>